/* eslint-disable */

import React, { Component } from "react";
import InputRange from "react-input-range";
import "./ActivityListing.css";
import {
  PackageZoneData,
  getTourPackageList,
  getTourFilterPackage,
  getalltransport
} from "../Component/axios";
import Autosuggest from "react-autosuggest";
import NewHeader from "../Component/NewHeader/NewHeader";
import moment from "moment";
import {Helmet} from "react-helmet";
import {
  RangeDatePicker,
  SingleDatePicker,
} from "react-google-flight-datepicker";
import "react-google-flight-datepicker/dist/main.css";

import DayPicker from "react-day-picker";
import "react-day-picker/lib/style.css";
import HotelListSkeleton from "../Component/HostelList/HotelListSkeleton";
import TourPackageList from "../TourList/TourPackageList";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faChild,
  faGlassMartiniAlt,
  faWifi,
  faEuroSign,
} from "@fortawesome/free-solid-svg-icons";
import Skeleton from "react-loading-skeleton";
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import  ExperiencesSoldout  from "./SoldOut/ExperiencesSoldout";
const ListNumber = [
  { id: "1" },
  { id: "2" },
  { id: "3" },
  { id: "4" },
  { id: "5" },
  { id: "6" },
  { id: "7" },
  { id: "8" },
  { id: "9" },
  { id: "10" },
  { id: "11" },
  { id: "12" },
  { id: "13" },
];

const SortArr = [
  { id: "4", name: "Recommended" },
  { id: "1", name: "Price - Low to High" },
  { id: "2", name: "Price - High to Low" },
  // { id: "3", name: "User Rating - High to Low" },
];

const Duration = [
  { id: "1", name: "Up to 1 hour" },
  { id: "2", name: "1 to 4 hours" },
  { id: "3", name: "4 hours to 1 day" },
  { id: "4", name: "1 to 3 days" },
  { id: "5", name: "3+ days" },
];
const TimeOfDays = [
  { id: "1", name: "6am—12pm" },
  { id: "2", name: "12pm—5pm" },
  { id: "3", name: "5pm—12am" },
];

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 5,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
export default class PackageListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      isOpen: false,
      dropdownVisible: false,
      selected: "Accommodations",
      searchInput: "",
      error: null,
      val: "",
      showResults: false,
      SelectedPlace: null,
      nav: false,
      searchData: "",
      sorting: false,
      sortingSelect: "Recommended",
      sortingId: null,
      value: "",
      suggestionsPackage: [],
      showResultsPackage: false,
      defaultZonevalPackage: "Seychelles",
      selectPackageDay: moment(new Date()).format("ddd, D MMM"),
      selectPackageDayNew: new Date(),
      checkinShowPackage: false,
      packageData: null,
      FiltersData: null,
      valuePrice: { min: 0, max: 10 },
      appliedFilterVal: [],
      checked: false,
      checkedItems: new Map(),
      packageList: null,
      packageListFilter: null,
      checkedTime: false,
      checked: [],
      expanded: [],
      CategotyThem:null
    };
  }

  componentDidMount() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const defaultZonevalPackageVal = urlParams.get("defaultZonevalPackageVal");
    const dateSelected = urlParams.get("dateSelected");
   
    this.setState({ defaultZonevalPackage: defaultZonevalPackageVal });
    this.setState({ selectPackageDayNew: dateSelected });
    this.setState({
      selectPackageDay: moment(dateSelected).format("ddd, D MMM"),
    });
    
    let JsonState = {
      defaultZonevalPackageVal: defaultZonevalPackageVal,
      dateSelected: moment(this.state.selectPackageDayNew).format("Y-MM-DD"),
    };
    const packageArr = JSON.stringify(JsonState);
    console.log(JSON.stringify(JsonState));

    PackageZoneData().then(
      (data) => {
        this.setState({
          itemsZonePackage: data,
        });
      },
      (error) => {
        this.setState({
          error,
        });
      }
    );

    const tour_type= {tour_type:"Package"}
    const tourtype = JSON.stringify(tour_type);
      getalltransport(tourtype).then(
        (data) => {
          console.log(data);
          
          this.setState({ CategotyThem:data.transport_mode_name});
        },
        (error) => {
          this.setState({
            error,
          });
        }
      );
    getTourPackageList(packageArr).then(
      (data) => {
        // this.setState({ packageData: data });
        if (data == undefined) {
          this.setState({
            packageData: null,
          });
        } else {
          // this.setState({
          //     packageData: data,
          // });
          this.setState({
            packageListFilter: data,
          });

          if (data == "no_package") {
            this.setState({
              packageData: data,
            });
          } else {
            this.SortingFunction(data);
          }
        }
      },
      (error) => {
        this.setState({
          error,
        });
      }
    );

    let JsonState1 = {
      defaultZonevalVal: defaultZonevalPackageVal,
      dateSelected: moment(this.state.selectPackageDayNew).format("Y-MM-DD"),
    };
    const packageArr1 = JSON.stringify(JsonState1);

    getTourFilterPackage(packageArr1).then(
      (data) => {
        console.log(data);
        this.setState({ FiltersData: data });
        this.setState({ valuePrice: { min: 0, max: data.max_price } });
      },
      (error) => {
        this.setState({
          error,
        });
      }
    );

    window.addEventListener("scroll", this.handleScroll);
  }

  SearchListing = () => {
    this.setState({
      FiltersData: null,
    });
    this.setState({
      packageData: null,
    });
    this.setState({
      sortingSelect: "Recommended",
    });

    let JsonState = {
      defaultZonevalPackageVal: this.state.defaultZonevalPackage,
      dateSelected: moment(this.state.selectPackageDayNew).format("Y-MM-DD"),
    };
    const hotelArr = JSON.stringify(JsonState);
    console.log(JSON.stringify(JsonState));
    PackageZoneData().then(
      (data) => {
        this.setState({
          itemsZonePackage: data,
        });
      },
      (error) => {
        this.setState({
          error,
        });
      }
    );

    getTourPackageList(hotelArr).then(
      (data) => {
        // this.setState({ packageData: data });
        if (data == undefined) {
          this.setState({
            packageData: null,
          });
        } else {
          // this.setState({
          //     packageData: data,
          // });
          this.setState({
            packageListFilter: data,
          });

          if (data == "no_package") {
            this.setState({
              packageData: data,
            });
          } else {
            this.SortingFunction(data);
          }
        }
      },
      (error) => {
        this.setState({
          error,
        });
      }
    );
    let JsonState1 = {
      defaultZonevalVal: this.state.defaultZonevalPackage,
      dateSelected: moment(this.state.selectPackageDayNew).format("Y-MM-DD"),
    };
    const hotelArr1 = JSON.stringify(JsonState1);

    getTourFilterPackage(hotelArr1).then(
      (data) => {
        this.setState({ FiltersData: data });
        this.setState({ valuePrice: { min: 0, max: data.max_price } });
      },
      (error) => {
        this.setState({
          error,
        });
      }
    );
  };

  SortingFunction = (data) => {
    if (data != "no_package") {
      console.log(data);
      const sorArr = data;
      const zeroElement = sorArr[0];

      setTimeout(() => {
        // const getValue = (price) => +price;
        // sorArr.sort(
        //   (a, b) =>
        //     getValue(
        //       Object.values(a).map((i, j) => {
        //         return i.tour_price;
        //       })
        //     ) -
        //     getValue(
        //       Object.values(b).map((i, j) => {
        //         return i.tour_price;
        //       })
        //     )
        // );

        console.log(sorArr);

        this.setState({
          packageData: sorArr,
        });
        this.setState({ packageListFilter: sorArr });
      }, 2000);
    }
  };

  sortingSearch = (data) => {
    console.log(this.state.sortingSelect);
    const sorArr = data;
    if (this.state.sortingSelect == "Price - Low to High") {
    
      setTimeout(() => {
        if (sorArr[0].matched) {
          const sliceArr = sorArr.shift();
          const getValue = (price) => +price;

          sorArr.sort(
            (a, b) =>
              getValue(
                Object.values(a).map((i, j) => {
                  return i.tour_price;
                })
              ) -
              getValue(
                Object.values(b).map((i, j) => {
                  return i.tour_price;
                })
              )
          );

          console.log(sorArr);

          this.setState({
            packageData: sorArr,
          });

          this.setState({ packageListFilter: sorArr });
        } else {
          const getValue = (price) => +price;
          sorArr.sort(
            (a, b) =>
              getValue(
                Object.values(a).map((i, j) => {
                  return i.tour_price;
                })
              ) -
              getValue(
                Object.values(b).map((i, j) => {
                  return i.tour_price;
                })
              )
          );

          console.log(sorArr);

          this.setState({
            packageData: sorArr,
          });
          this.setState({ packageListFilter: sorArr });
        }
      }, 2000);
    } else if (this.state.sortingSelect == "Price - High to Low") {
      setTimeout(() => {
        const getValue = (price) => -price;

        // const getValue = (price) => +price;
        sorArr.sort(
          (a, b) =>
            getValue(
              Object.values(a).map((i, j) => {
                return i.tour_price;
              })
            ) -
            getValue(
              Object.values(b).map((i, j) => {
                return i.tour_price;
              })
            )
        );

        console.log(sorArr);

        this.setState({
          packageData: sorArr,
        });
        this.setState({ packageListFilter: sorArr });
      }, 2000);
    } else if (this.state.sortingSelect == "Recommended") {
      setTimeout(() => {

        const getValue = (price) => price;

        sorArr.sort(
          (a, b) =>
            getValue(
              Object.values(a).map((i, j) => {
                return i.tour_price;
              })
            ) -
            getValue(
              Object.values(b).map((i, j) => {
                return i.tour_price;
              })
            )
        );
        this.setState({
          activityData: sorArr,
        });
        this.setState({ packageListFilter: sorArr });
      }, 2000);
    }
  };

  componentWillUnmount() {
    // document.removeEventListener('click', this.globalClickListener)
    window.removeEventListener("click", this.globalClickListener);
    window.removeEventListener("scroll", this.handleScroll);
  }
  globalClickListener = (nativeEvent) => {
    this.setState(
      {
        dropdownVisible: false,
        showResults: false,
        checkinShow: false,
        showResultsPackage: false,
        checkinShowPackage: false,
        showResultsPackage: false,
        checkinShowPackage: false,
        showResultsTransfer: false,
        checkinShowTransfer: false,
      },
      () => {
        console.log("global click");
        console.log(this.state.showResults);
        // document.removeEventListener('click', this.globalClickListener)
        window.removeEventListener("click", this.globalClickListener);
      }
    );
  };

  checkinandcheckoutPackage = (syntheticEvent) => {
    console.log("toggle dropdown");
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ checkinShowPackage: !prevState.checkinShowPackage }),
      () => {
        if (this.state.checkinShowPackage) {
          console.log(this.state.checkinShowPackage);

          // document.addEventListener('click', this.globalClickListener)
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
    // console.log(this.state.dropdownVisible);
  };

  handleBodyClick = (event) => {
    console.log("body click");
    event.stopPropagation();
  };

  showSorting = (syntheticEvent) => {
    console.log("toggle dropdown");
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ sorting: !prevState.sorting }),
      () => {
        if (this.state.sorting) {
          console.log(this.state.sorting);

          // document.addEventListener('click', this.globalClickListener)
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
  };
  getSuggestionsPackage = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0
      ? []
      : this.state.itemsZonePackage.filter(
          (lang) => lang.Name.toLowerCase().slice(0, inputLength) === inputValue
        );
  };

  onSuggestionsFetchRequestedPackage = ({ value }) => {
    this.setState({
      suggestionsPackage: this.getSuggestionsPackage(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequestedPackage = () => {
    this.setState({
      suggestionsPackage: [],
    });
  };

  onSuggestionSelectedPackage = () => {
    this.setState({
      showResultsPackage: false,
    });
  };

  getSuggestionValuePackage = (suggestion) => suggestion.Name;

  // Use your imagination to render suggestions.
  renderSuggestionPackage = (suggestion, { query, isHighlighted }) => (
    <div className="font14 darkText  noChild  clickable">
      <div className="hsFlexspaceBetween hsFlex hrtlCenter ">
        {suggestion.LocationImage != "nolocation" ? (
          <div className="locationImage">
            <img
              src={suggestion.LocationImage}
              className="locationImageContent"
            />
          </div>
        ) : (
          <div className="tourImage">
            {" "}
            <img src={suggestion.Image} className="locationImageContent2" />
          </div>
        )}
        <div className="flexOne">
          <p className="locusLabel appendBottom5 fontSizeChange">
            {suggestion.Name}
          </p>
        </div>
      </div>
    </div>
  );

  renderSuggestionsContainerPackage = ({ containerProps, children }) => {
    return (
      <div {...containerProps}>
        <div class="react-autosuggest__section-title">
          <label class="hsw_sectionTitle font12 latoBlack greyText">
          Suggestions{" "}
          </label>
        </div>
        <div> {children}</div>
      </div>
    );
  };

  showZonelistdivPackage = (syntheticEvent) => {
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ showResultsPackage: !prevState.showResultsPackage }),
      () => {
        if (this.state.showResultsPackage) {
          console.log(this.state.showResultsPackage);

          // document.addEventListener('click', this.globalClickListener)
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
  };

  onChangePackage = (event, { newValue }) => {
    console.log(newValue);
    this.setState({
      value: newValue,
      defaultZonevalPackage: newValue,
    });
  };

  handlePackageDayClick = (day) => {
    console.log(day);
    this.setState({ selectPackageDayNew: day });
    this.setState({ selectPackageDay: moment(day).format("ddd, D MMM") });
    this.setState({ checkinShowPackage: false });
  };

  handleScroll = () => {
    if (window.pageYOffset > 10) {
      if (!this.state.nav) {
        this.setState({ nav: true });
      }
    } else {
      if (this.state.nav) {
        this.setState({ nav: false });
      }
    }
  };

  handleSortingChange = (e) => {
    this.setState({
      packageData: null,
    });

    const sorArr = this.state.packageData;
    console.log(sorArr);

    if (e.id == 2) {
      setTimeout(() => {
        const getValue = (price) => -price;

        sorArr.sort(
          (a, b) =>
            getValue(
              Object.values(a).map((i, j) => {
                return i.tour_price;
              })
            ) -
            getValue(
              Object.values(b).map((i, j) => {
                return i.tour_price;
              })
            )
        );

        console.log(sorArr);

        this.setState({
          packageData: sorArr,
        });
      }, 2000);
    } else if (e.id == 3) {
      setTimeout(() => {
        const getValue = (star) => -star;
        sorArr.sort((a, b) => getValue() - getValue());

        console.log(sorArr);

        this.setState({
          packageData: sorArr,
        });
      }, 2000);
    } else if (e.id == 1) {
      setTimeout(() => {
        const getValue = (price) => +price;
        sorArr.sort(
          (a, b) =>
            getValue(
              Object.values(a).map((i, j) => {
                return i.tour_price;
              })
            ) -
            getValue(
              Object.values(b).map((i, j) => {
                return i.tour_price;
              })
            )
        );

        console.log(sorArr);

        this.setState({
          packageData: sorArr,
        });
      }, 2000);
    } else if (e.id == 4) {
      setTimeout(() => {
        const getValue = (id) => id;
        sorArr.sort(
          (a, b) =>
            getValue(
              Object.values(a).map((i, j) => {
                return i.tour_data.id;
              })
            ) -
            getValue(
              Object.values(b).map((i, j) => {
                return i.tour_data.id;
              })
            )
        );


        this.setState({
          packageData: sorArr,
        });
        // this.setState({
        //   SkeletonData: false,
        // });
      }, 2000);
    }

    this.setState({
      sortingSelect: e.name,
    });

    this.setState({
      sortingId: e.id,
    });
  };

  CheckAppliedFilterLocation = () => {
  
    this.setState({ packageData: null });

    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    console.log(value);
    const name = target.name;
    let applied = [...this.state.appliedFilterVal];

    const isChecked = event.target.checked;

    if (value) {
      this.setState({
        appliedFilterVal: [...applied, { label: name, value: value }],
      });
    } else {
      let applied = [...this.state.appliedFilterVal];

      let index = applied.length - 1;

      applied.splice(index, 1);

      this.setState({
        appliedFilterVal: applied,
      });
    }
    // this.setState({checked: value});
    this.setState((prevState) => ({
      checkedItems: prevState.checkedItems.set(name, isChecked),
    }));

    const packagedData = [...this.state.packageListFilter];

    const result = [];

  setTimeout(() => {

    packagedData && packagedData.map((i, j) => {
      if (i != "no_package") {
          Object.values(i).map((key1, index) => {
              if(this.state.appliedFilterVal.length> 0){
              this.state.appliedFilterVal.map((item, index) => {
                  // if (key1.tour_data.tour_region_name.toLowerCase().trim() === item.label) {
                  //   result.push(i);
                  // }
                  if(this.state.defaultZonevalPackage.toLowerCase().trim() === 'seychelles'){
                    if(key1.tour_data.tour_region_name.toLowerCase().trim() === item.label) {
                      result.push(i);
                    }
                  }else{
                    if(key1.tour_data.tour_location.toLowerCase().trim() === item.label){
                      result.push(i);
                    }
                  }
                });
            }
          });
        }
      });
  }, 2000); 
    
    console.log(result);

    setTimeout(() => {
      this.setState({ packageData: result });
    }, 2000);

    setTimeout(() => {
      if (this.state.appliedFilterVal.length == 0) {
        this.setState({ packageData: packagedData });
      }
    }, 2000);
  };
  CheckAppliedFilterCategory = (nodecheck) => {

    this.setState({checked : nodecheck})
    this.setState({ packageData: null });
    this.setState({
      SkeletonData: true,
    });

    //   let applied = [...this.state.appliedFilterVal];
    // //nodecheck.map((item, index) => {
    //   const newItem = (nodecheck).pop();
    //   if(newItem){
    //     this.setState({
    //       appliedFilterVal: [...applied, { label: newItem, value: newItem }],
    //     });
    //   }else{
    //     let applied = [...this.state.appliedFilterVal];

    //     let index = applied.length - 1;
  
    //     applied.splice(index, 1);
  
    //     this.setState({
    //       appliedFilterVal: applied,
    //     });
    //   }
      
   // })  
 const packageData =  [...this.state.packageListFilter];
if(nodecheck.length){
 
const result = [];
      packageData && packageData.map((i, j) => {
        if (i != "no_package") {
          Object.values(i).map((key1, index) => {
            console.log(key1);
            if (nodecheck.length > 0) {
             nodecheck.map((item, index) => {
                  if (key1.tour_data.transport_mode_name.toLowerCase().trim() === item) {
                    result.push(i);
                  }
             
              });
            }
          });
        }
      });
 
    setTimeout(() => {
             this.setState({ packageData: result });
            this.setState({
              SkeletonData: false,
            });
          }, 1000);
}else{
      setTimeout(() => {
      if (this.state.appliedFilterVal.length == 0) {
        this.setState({ packageData: packageData });
        this.setState({
          SkeletonData: false,
        });
      }
    }, 1000);
}

  };


  
  CheckAppliedFilter = () => {
    // //console.log(hotelData);
    this.setState({ packageData: null });

    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    //console.log(value);
    const name = target.name;
    let applied = [...this.state.appliedFilterVal];

    const isChecked = event.target.checked;

    if (value) {
      this.setState({
        appliedFilterVal: [...applied, { label: name, value: value }],
      });
    } else {
      let applied = [...this.state.appliedFilterVal];

      let index = applied.length - 1;

      applied.splice(index, 1);

      this.setState({
        appliedFilterVal: applied,
      });
    }
    // this.setState({checked: value});
    this.setState((prevState) => ({
      checkedItems: prevState.checkedItems.set(name, isChecked),
    }));

    const packageData = [...this.state.packageListFilter];

    console.log(packageData);

    const result = [];

    //console.log(name);

    setTimeout(() => {
      packageData.map((i, j) => {
        if (i != 'no_package') {
          Object.values(i).map((key1, index) => {

            if (this.state.appliedFilterVal.length > 0) {
              this.state.appliedFilterVal.map((item, index) => {
                console.log(item)
                if (item.label == "Up to 1 hour") {
                  const minvalue = 0;
                  const maxvalue = 1;
                  //console.log(key1.tour_duration.normal_hours)
                  if (
                    parseInt(key1.tour_duration.normal_hours) >= minvalue &&
                    parseInt(key1.tour_duration.normal_hours) <= maxvalue
                  ) {
                    result.push(i);
                  }
                } else if (item.label == "1 to 4 hours") {
                  const minvalue = 1;
                  const maxvalue = 4;
                  if (
                    parseInt(key1.tour_duration.normal_hours) >= minvalue &&
                    parseInt(key1.tour_duration.normal_hours) <= maxvalue
                  ) {
                    result.push(i);
                  }
                } else if (item.label == "4 hours to 1 day") {
                  const minvalue = 4;
                  const maxvalue = 24;
                  if (
                    parseInt(key1.tour_duration.normal_hours) >= minvalue &&
                    parseInt(key1.tour_duration.normal_hours) <= maxvalue
                  ) {
                    result.push(i);
                  }
                } else if (item.label == "1 to 3 days") {
                  const mindays = 1;
                  const maxdays = 3;
                  if (
                    parseInt(key1.tour_duration.day_number) >= mindays &&
                    parseInt(key1.tour_duration.day_number) <= maxdays
                  ) {
                    result.push(i);
                  }
                } else if (item.label == "3+ days") {
                  const mindays = 3;

                  if (
                    parseInt(key1.tour_duration.day_number) >= mindays &&
                    parseInt(key1.tour_duration.day_number) < mindays
                  ) {
                    result.push(i);
                  }
                }
              });
            } else {
              result.push(i);
            }
          });

        }

      });
    }, 2000);

    setTimeout(() => {
      this.setState({ packageData: result });
    }, 2000);

    setTimeout(() => {
      if (this.state.appliedFilterVal.length == 0) {
        this.setState({ packageData: packageData });
      }
    }, 2000);
  };


  //Time Data

 
  CheckTimeOfDaysFilter = () => {
    // //console.log(hotelData);
    this.setState({ packageData: null });

    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    //console.log(value);
    const name = target.name;
    let applied = [...this.state.appliedFilterVal];

    const isChecked = event.target.checked;

    if (value) {
      this.setState({
        appliedFilterVal: [...applied, { label: name, value: value }],
      });
    } else {
      let applied = [...this.state.appliedFilterVal];

      let index = applied.length - 1;

      applied.splice(index, 1);

      this.setState({
        appliedFilterVal: applied,
      });
    }
    // this.setState({checked: value});
    this.setState((prevState) => ({
      checkedItems: prevState.checkedItems.set(name, isChecked),
    }));

    const packageData = [...this.state.packageListFilter];

    //console.log(packageData);

    const result = [];

    //console.log(name);

    setTimeout(() => {
      packageData.map((i, j) => {
        {
          Object.values(i).map((key1, index) => {
            let checkTime = false;
            if (key1.tour_time) {
              key1.tour_time.map((key2, index) => {
                if (this.state.appliedFilterVal.length > 0) {
                  this.state.appliedFilterVal.map((item, index) => {
                    if (item.label == "6am—12pm") {
                      const from_time = "05:59 am";
                      const lost_time = "12:01 pm";
                      const maxvalue = 1;
                      var dt1 = moment(from_time, ["h:mm A"]).format("HH:mm");
                      var dt2 = moment(key2.from_time, ["h:mm A"]).format(
                        "HH:mm"
                      );
                      var dt3 = moment(lost_time, ["h:mm A"]).format("HH:mm");
                      //console.log("Niddle time: " + dt1 + " --- loop time: " + dt2);
                      const startTime = dt1; //'01/01/2011 10:20:45';
                      const endTime = dt2; //'01/01/2011 5:10:10';
                      var regExp = /(\d{1,2})\:(\d{1,2})\:(\d{1,2})/;
                      if (
                        parseInt(endTime.replace(regExp, "$1$2$3")) >
                        parseInt(startTime.replace(regExp, "$1$2$3")) &&
                        parseInt(endTime.replace(regExp, "$1$2$3")) <
                        parseInt(dt3.replace(regExp, "$1$2$3"))
                      ) {
                        //console.log("push in array   --- " + startTime + "===" + dt3 + "===" + endTime);

                        checkTime = true;
                        return checkTime;
                      } else {
                        //console.log("skip  --- " + startTime + "===" + dt3 + "===" + endTime);
                      }
                    } else if (item.label == "12pm—5pm") {
                      const from_time = "12:01 pm";
                      const lost_time = "05:00 pm";
                      const maxvalue = 1;
                      var dt1 = moment(from_time, ["h:mm A"]).format("HH:mm");
                      var dt2 = moment(key2.from_time, ["h:mm A"]).format(
                        "HH:mm"
                      );
                      var dt3 = moment(lost_time, ["h:mm A"]).format("HH:mm");
                      //console.log("Niddle time: " + dt1 + " --- loop time: " + dt2);
                      const startTime = dt1; //'01/01/2011 10:20:45';
                      const endTime = dt2; //'01/01/2011 5:10:10';
                      var regExp = /(\d{1,2})\:(\d{1,2})\:(\d{1,2})/;
                      if (
                        parseInt(endTime.replace(regExp, "$1$2$3")) >
                        parseInt(startTime.replace(regExp, "$1$2$3")) &&
                        parseInt(endTime.replace(regExp, "$1$2$3")) <
                        parseInt(dt3.replace(regExp, "$1$2$3"))
                      ) {
                        // //console.log("push in array   --- "+startTime+"==="+dt3+"==="+endTime);
                        checkTime = true;
                        return checkTime;
                      } else {
                        //console.log("skip  --- " + startTime + "===" + dt3 + "===" + endTime);
                      }
                    } else if (item.label == "5pm—12am") {
                      const from_time = "05:01 pm";
                      const lost_time = "12:01 am";
                      const maxvalue = 1;
                      var dt1 = moment(from_time, ["h:mm A"]).format("HH:mm");
                      var dt2 = moment(key2.from_time, ["h:mm A"]).format(
                        "HH:mm"
                      );
                      var dt3 = moment(lost_time, ["h:mm A"]).format("HH:mm");
                      //console.log("Niddle time: " + dt1 + " --- loop time: " + dt2);
                      const startTime = dt1; //'01/01/2011 10:20:45';
                      const endTime = dt2; //'01/01/2011 5:10:10';
                      var regExp = /(\d{1,2})\:(\d{1,2})\:(\d{1,2})/;
                      if (
                        parseInt(endTime.replace(regExp, "$1$2$3")) >
                        parseInt(startTime.replace(regExp, "$1$2$3")) &&
                        parseInt(endTime.replace(regExp, "$1$2$3")) <
                        parseInt(dt3.replace(regExp, "$1$2$3"))
                      ) {
                        ////console.log("push in array   --- "+startTime+"==="+dt3+"==="+endTime);
                        checkTime = true;
                        return checkTime;
                      } else {
                        //console.log("skip  --- " + startTime + "===" + dt3 + "===" + endTime);
                      }
                    }
                  });
                }
              });
            }


            if (checkTime) {
              result.push(i);
            }
          });
        }
      });
    }, 2000);

    //console.log(result);

    setTimeout(() => {
      this.setState({ packageData: result });
    }, 2000);

    setTimeout(() => {
      if (this.state.appliedFilterVal.length == 0) {
        this.setState({ packageData: packageData });
      }
    }, 2000);
  };


  changePrice = (value) => {
    this.setState({ packageData: null });
    console.log(value);
    //  this.setState({ valuePrice: value })

    let name = value.min + "-" + value.max;
    let applied = [...this.state.appliedFilterVal];

    let catlength = applied.length;
    let PriceRangeVal = "abc";
    //var i = 0;

    applied.map((i, j) => {
      if (i.value == "priceRange") {
        PriceRangeVal = j;
        return PriceRangeVal;
      }
    });

    // console.log(PriceRangeVal);
    if (PriceRangeVal == "abc") {
      this.setState({
        appliedFilterVal: [...applied, { label: name, value: "priceRange" }],
      });
    } else {
      applied[PriceRangeVal] = { label: name, value: "priceRange" };
      this.setState({
        appliedFilterVal: applied,
      });
    }

    const packagedData = [...this.state.packageListFilter];

    const result = [];

    packagedData.map((i, j) => {
      {
        Object.values(i).map((key1, index) => {
          console.log(key1);
          if (
            parseInt(key1.tour_price) >= value.min &&
            parseInt(key1.tour_price) <= value.max
          ) {
            result.push(i);
          }
        });
      }
    });

    console.log(result);

    setTimeout(() => {
      this.setState({ packageData: result });
    }, 2000);
  };

  RemoveSingleFilter = (i, index, maxValue) => {
    console.log(index);
    this.setState({ packageData: null });

    let applied = [...this.state.appliedFilterVal];

    applied.splice(index, 1);

    this.setState({
      appliedFilterVal: applied,
    });

    document.getElementsByName(i.label).checked = false;

    this.setState((prevState) => prevState.checkedItems.set(i.label, false));

    let PriceRange = { min: 0, max: maxValue };

    this.setState({ valuePrice: PriceRange });

    const packagedData = [...this.state.packageListFilter];

    const result = [];

    setTimeout(() => {
      packagedData.map((i, j) => {
        Object.values(i).map((key1, index) => {
          let checkTime = false;
          // Duration Data Filter
          if (this.state.appliedFilterVal.length > 0) {
            this.state.appliedFilterVal.map((item, index) => {
              if (item.label == "Up to 1 hour") {
                const minvalue = 0;
                const maxvalue = 1;
                if (
                  parseInt(key1.tour_duration.normal_hours) >= minvalue &&
                  parseInt(key1.tour_duration.normal_hours) <= maxvalue
                ) {
                  result.push(i);
                }
              } else if (item.label == "1 to 4 hours") {
                const minvalue = 1;
                const maxvalue = 4;
                if (
                  parseInt(key1.tour_duration.normal_hours) >= minvalue &&
                  parseInt(key1.tour_duration.normal_hours) <= maxvalue
                ) {
                  result.push(i);
                }
              } else if (item.label == "4 hours to 1 day") {
                const minvalue = 4;
                const maxvalue = 24;
                if (
                  parseInt(key1.tour_duration.normal_hours) >= minvalue &&
                  parseInt(key1.tour_duration.normal_hours) <= maxvalue
                ) {
                  result.push(i);
                }
              } else if (item.label == "1 to 3 days") {
                const mindays = 1;
                const maxdays = 3;
                if (
                  parseInt(key1.tour_duration.day_number) >= mindays &&
                  parseInt(key1.tour_duration.day_number) <= maxdays
                ) {
                  result.push(i);
                }
              } else if (item.label == "3+ days") {
                const mindays = 3;

                if (
                  parseInt(key1.tour_duration.day_number) >= mindays &&
                  parseInt(key1.tour_duration.day_number) < mindays
                ) {
                  result.push(i);
                }
              }

              // if (parseInt(key1.tour_price) >= value.min && parseInt(key1.tour_price) <= value.max) {
              //     result.push(i);
              // }
            });

            //Price Remove Data
          } else {
            result.push(i);
          }
        });
      });
    }, 2000);

    setTimeout(() => {
      packagedData.map((i, j) => {
        {
          Object.values(i).map((key1, index) => {
            let checkTime = false;
            console.log(key1.tour_time);
            key1.tour_time.map((key2, index) => {
              if (this.state.appliedFilterVal.length > 0) {
                this.state.appliedFilterVal.map((item, index) => {
                  console.log(key2.from_time);
                  console.log(name);

                  if (item.label == "6am—12pm") {
                    const from_time = "05:59 am";
                    const lost_time = "12:01 pm";
                    const maxvalue = 1;
                    var dt1 = moment(from_time, ["h:mm A"]).format("HH:mm");
                    var dt2 = moment(key2.from_time, ["h:mm A"]).format(
                      "HH:mm"
                    );
                    var dt3 = moment(lost_time, ["h:mm A"]).format("HH:mm");
                    console.log(
                      "Niddle time: " + dt1 + " --- loop time: " + dt2
                    );
                    const startTime = dt1; //'01/01/2011 10:20:45';
                    const endTime = dt2; //'01/01/2011 5:10:10';
                    var regExp = /(\d{1,2})\:(\d{1,2})\:(\d{1,2})/;
                    if (
                      parseInt(endTime.replace(regExp, "$1$2$3")) >
                        parseInt(startTime.replace(regExp, "$1$2$3")) &&
                      parseInt(endTime.replace(regExp, "$1$2$3")) <
                        parseInt(dt3.replace(regExp, "$1$2$3"))
                    ) {
                      console.log(
                        "push in array   --- " +
                          startTime +
                          "===" +
                          dt3 +
                          "===" +
                          endTime
                      );

                      checkTime = true;
                      return checkTime;
                    } else {
                      console.log(
                        "skip  --- " + startTime + "===" + dt3 + "===" + endTime
                      );
                    }
                  } else if (item.label == "12pm—5pm") {
                    const from_time = "12:01 pm";
                    const lost_time = "05:00 pm";
                    const maxvalue = 1;
                    var dt1 = moment(from_time, ["h:mm A"]).format("HH:mm");
                    var dt2 = moment(key2.from_time, ["h:mm A"]).format(
                      "HH:mm"
                    );
                    var dt3 = moment(lost_time, ["h:mm A"]).format("HH:mm");
                    console.log(
                      "Niddle time: " + dt1 + " --- loop time: " + dt2
                    );
                    const startTime = dt1; //'01/01/2011 10:20:45';
                    const endTime = dt2; //'01/01/2011 5:10:10';
                    var regExp = /(\d{1,2})\:(\d{1,2})\:(\d{1,2})/;
                    if (
                      parseInt(endTime.replace(regExp, "$1$2$3")) >
                        parseInt(startTime.replace(regExp, "$1$2$3")) &&
                      parseInt(endTime.replace(regExp, "$1$2$3")) <
                        parseInt(dt3.replace(regExp, "$1$2$3"))
                    ) {
                      // console.log("push in array   --- "+startTime+"==="+dt3+"==="+endTime);
                      checkTime = true;
                      return checkTime;
                    } else {
                      console.log(
                        "skip  --- " + startTime + "===" + dt3 + "===" + endTime
                      );
                    }
                  } else if (item.label == "5pm—12am") {
                    const from_time = "05:01 pm";
                    const lost_time = "12:01 am";
                    const maxvalue = 1;
                    var dt1 = moment(from_time, ["h:mm A"]).format("HH:mm");
                    var dt2 = moment(key2.from_time, ["h:mm A"]).format(
                      "HH:mm"
                    );
                    var dt3 = moment(lost_time, ["h:mm A"]).format("HH:mm");
                    console.log(
                      "Niddle time: " + dt1 + " --- loop time: " + dt2
                    );
                    const startTime = dt1; //'01/01/2011 10:20:45';
                    const endTime = dt2; //'01/01/2011 5:10:10';
                    var regExp = /(\d{1,2})\:(\d{1,2})\:(\d{1,2})/;
                    if (
                      parseInt(endTime.replace(regExp, "$1$2$3")) >
                        parseInt(startTime.replace(regExp, "$1$2$3")) &&
                      parseInt(endTime.replace(regExp, "$1$2$3")) <
                        parseInt(dt3.replace(regExp, "$1$2$3"))
                    ) {
                      //console.log("push in array   --- "+startTime+"==="+dt3+"==="+endTime);
                      checkTime = true;
                      return checkTime;
                    } else {
                      console.log(
                        "skip  --- " + startTime + "===" + dt3 + "===" + endTime
                      );
                    }
                  }
                });
              }
            });

            if (checkTime) {
              result.push(i);
            }
          });
        }
      });
    }, 2000);

    console.log(result);

    setTimeout(() => {
      this.setState({ packageData: result });
    }, 2000);

    setTimeout(() => {
      if (this.state.appliedFilterVal.length == 0) {
        this.setState({ packageData: packagedData });
      }
    }, 2000);
  };

  RemoveMultipleFilter = (maxValue) => {
    this.setState({ packageData: null });
    this.setState({
      appliedFilterVal: [],
    });
    this.setState({ liveaboardList: null });
    let PriceRange = { min: 0, max: maxValue };

    this.setState({ valuePrice: PriceRange });

    const clearCheckedItems = new Map();
    this.setState({ checkedItems: clearCheckedItems });

    const packagedData = [...this.state.packageListFilter];

    setTimeout(() => {
      this.setState({ packageData: packagedData });
    }, 2000);
  };

  render() {
  //  console.log(this.state.packageData);
  //  console.log(this.state.FiltersData);
    const menuClass = `panel-dropdown${
      this.state.dropdownVisible ? " active" : ""
    }`;
    const { value, suggestionsPackage } = this.state;

    const inputPropsPackage = {
      placeholder: "Enter location",
      type: "search",
      value,
      onChange: this.onChangePackage,
    };
    return (
      <React.Fragment>
        <div>
        <Helmet>
      <title>Best packages in Seychelles- Holidays Seychelles</title>
        <meta name="description" content="Get best booking rates and packages for beautiful attractions in Seychelles." />
        <meta name="keywords" content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"/>
      </Helmet>
      <h1 style={{color:'#fff'}}>Best packages in Seychelles- Holidays Seychelles</h1>
          <NewHeader page={"inner_listing"} tabName={3} />
          <div
            className={`${
              this.state.nav == true
                ? "_Hlisting_header_new"
                : "_Hlisting_header"
            }`}
          >
            <div className="container hsw">
              <div className="hsw_inner">
                <div
                  className="hsw_inputBoxActivity  "
                  onClick={this.showZonelistdivPackage}
                >
                  <label
                    for="city"
                    className="lbl_input latoBold font12 blueText"
                  >
                 Location
                  </label>
                  <p
                    className="hsw_inputField font16 whiteText"
                    style={{ marginBottom: "3px" }}
                  >
                    {this.state.defaultZonevalPackage.length >= 35
                      ? `${this.state.defaultZonevalPackage.substring(
                          0,
                          35
                        )}...`
                      : this.state.defaultZonevalPackage}
                  </p>
                  <div className="focused_div">
                    {this.state.showResultsPackage ? (
                      <div
                        className="autocomplete-wrapper"
                        style={{ top: 30 }}
                        onClick={this.handleBodyClick}
                      >
                        <Autosuggest
                          suggestions={suggestionsPackage}
                          onSuggestionsFetchRequested={
                            this.onSuggestionsFetchRequestedPackage
                          }
                          onSuggestionSelected={
                            this.onSuggestionSelectedPackage
                          }
                          onSuggestionsClearRequested={
                            this.onSuggestionsClearRequestedPackage
                          }
                          getSuggestionValue={this.getSuggestionValuePackage}
                          renderSuggestionsContainer={
                            this.renderSuggestionsContainerPackage
                          }
                          renderSuggestion={this.renderSuggestionPackage}
                          inputProps={inputPropsPackage}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <div
                  className="hsw_inputBoxActivity"
                  onClick={this.checkinandcheckoutPackage}
                >
                  <span className="checkinandcheckout">
                    <label
                      for="checkin"
                      className="lbl_input latoBold font12 blueText capText"
                    >
                      When are you traveling?
                    </label>
                  </span>
                  <p className="hsw_inputField font16 whiteText">
                    {this.state.selectPackageDay}
                  </p>
                  <div onClick={this.handleBodyClick}>
                    {this.state.checkinShowPackage && (
                      <DayPicker
                        className="activityDate"
                        onDayClick={this.handlePackageDayClick}
                        selectedDays={this.state.selectPackageDayNew}
                        disabledDays={{ before: new Date() }}
                      />
                    )}
                  </div>
                </div>
                <span
                  className="primaryBtn hsw_searchButton"
                  onClick={this.SearchListing}
                >
                  Search
                </span>
              </div>
            </div>
          </div>
      

          <div className="container makeFlex spaceBetween">
            <div
              className="container makeFlex spaceBetween"
              style={{ marginTop: 50, padding: "10px" }}
            >
              {this.state.packageData == "no_package" || this.state.packageData == null?(
                <></>
              ) : (
                <>
                  {this.state.FiltersData == null ? (
                    <>
                      <div className="filterWrap appendRight30">
                        <div className="appendBottom35">
                          <p className="makeFlex spaceBetween end">
                            <span className="latoBold font20 blackText">
                              <Skeleton style={{ width: 240, height: 30 }} />
                            </span>
                          </p>

                          <div
                            className="filterRow"
                            id="hlistpg_fr_star_category"
                          >
                            <div className="latoBold font16 blackText appendBottom15 makeFlex hrtlCenter">
                              <Skeleton style={{ width: 240, height: 26 }} />
                            </div>
                            <ul className="filterList">
                              <li>
                                <label>
                                  <Skeleton style={{ width: 20, height: 20 }} />
                                  <Skeleton
                                    style={{
                                      width: 190,
                                      height: 15,
                                      marginLeft: 10,
                                    }}
                                  />
                                </label>
                              </li>
                              <li>
                                <label>
                                  <Skeleton style={{ width: 20, height: 20 }} />
                                  <Skeleton
                                    style={{
                                      width: 190,
                                      height: 15,
                                      marginLeft: 10,
                                    }}
                                  />
                                </label>
                              </li>
                              <li>
                                <label>
                                  <Skeleton style={{ width: 20, height: 20 }} />
                                  <Skeleton
                                    style={{
                                      width: 190,
                                      height: 15,
                                      marginLeft: 10,
                                    }}
                                  />
                                </label>
                              </li>
                              <li>
                                <label>
                                  <Skeleton style={{ width: 20, height: 20 }} />
                                  <Skeleton
                                    style={{
                                      width: 190,
                                      height: 15,
                                      marginLeft: 10,
                                    }}
                                  />
                                </label>
                              </li>
                              <li>
                                <label>
                                  <Skeleton style={{ width: 20, height: 20 }} />
                                  <Skeleton
                                    style={{
                                      width: 190,
                                      height: 15,
                                      marginLeft: 10,
                                    }}
                                  />
                                </label>
                              </li>
                              <li>
                                <label>
                                  <Skeleton style={{ width: 20, height: 20 }} />
                                  <Skeleton
                                    style={{
                                      width: 190,
                                      height: 15,
                                      marginLeft: 10,
                                    }}
                                  />
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div
                          className="filterRow"
                          id="hlistpg_fr_star_category"
                        >
                          <div className="latoBold font16 blackText appendBottom15 makeFlex hrtlCenter">
                            <Skeleton style={{ width: 240, height: 26 }} />
                          </div>
                          <ul className="filterList">
                            <li>
                              <label>
                                <Skeleton style={{ width: 20, height: 20 }} />
                                <Skeleton
                                  style={{
                                    width: 190,
                                    height: 15,
                                    marginLeft: 10,
                                  }}
                                />
                              </label>
                            </li>
                            <li>
                              <label>
                                <Skeleton style={{ width: 20, height: 20 }} />
                                <Skeleton
                                  style={{
                                    width: 190,
                                    height: 15,
                                    marginLeft: 10,
                                  }}
                                />
                              </label>
                            </li>
                            <li>
                              <label>
                                <Skeleton style={{ width: 20, height: 20 }} />
                                <Skeleton
                                  style={{
                                    width: 190,
                                    height: 15,
                                    marginLeft: 10,
                                  }}
                                />
                              </label>
                            </li>
                            <li>
                              <label>
                                <Skeleton style={{ width: 20, height: 20 }} />
                                <Skeleton
                                  style={{
                                    width: 190,
                                    height: 15,
                                    marginLeft: 10,
                                  }}
                                />
                              </label>
                            </li>
                            <li>
                              <label>
                                <Skeleton style={{ width: 20, height: 20 }} />
                                <Skeleton
                                  style={{
                                    width: 190,
                                    height: 15,
                                    marginLeft: 10,
                                  }}
                                />
                              </label>
                            </li>
                            <li>
                              <label>
                                <Skeleton style={{ width: 20, height: 20 }} />
                                <Skeleton
                                  style={{
                                    width: 190,
                                    height: 15,
                                    marginLeft: 10,
                                  }}
                                />
                              </label>
                            </li>
                          </ul>
                        </div>

                        <div
                          className="filterRow"
                          id="hlistpg_fr_star_category"
                        >
                          <div className="latoBold font16 blackText appendBottom15 makeFlex hrtlCenter">
                            <Skeleton style={{ width: 240, height: 26 }} />
                          </div>
                          <ul className="filterList">
                            <li>
                              <label>
                                <Skeleton style={{ width: 20, height: 20 }} />
                                <Skeleton
                                  style={{
                                    width: 190,
                                    height: 15,
                                    marginLeft: 10,
                                  }}
                                />
                              </label>
                            </li>
                            <li>
                              <label>
                                <Skeleton style={{ width: 20, height: 20 }} />
                                <Skeleton
                                  style={{
                                    width: 190,
                                    height: 15,
                                    marginLeft: 10,
                                  }}
                                />
                              </label>
                            </li>
                            <li>
                              <label>
                                <Skeleton style={{ width: 20, height: 20 }} />
                                <Skeleton
                                  style={{
                                    width: 190,
                                    height: 15,
                                    marginLeft: 10,
                                  }}
                                />
                              </label>
                            </li>
                            <li>
                              <label>
                                <Skeleton style={{ width: 20, height: 20 }} />
                                <Skeleton
                                  style={{
                                    width: 190,
                                    height: 15,
                                    marginLeft: 10,
                                  }}
                                />
                              </label>
                            </li>
                            <li>
                              <label>
                                <Skeleton style={{ width: 20, height: 20 }} />
                                <Skeleton
                                  style={{
                                    width: 190,
                                    height: 15,
                                    marginLeft: 10,
                                  }}
                                />
                              </label>
                            </li>
                            <li>
                              <label>
                                <Skeleton style={{ width: 20, height: 20 }} />
                                <Skeleton
                                  style={{
                                    width: 190,
                                    height: 15,
                                    marginLeft: 10,
                                  }}
                                />
                              </label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="filterWrap appendRight30">
                      {this.state.appliedFilterVal.length > 0 ? (
                        <div className="appliedFiltersContainer">
                          <div
                            className="makeFlex spaceBetween end appendBottom20"
                            style={{
                              marginBottom: 10,
                              justifyContent: "space-between",
                            }}
                          >
                            <span className="font20 blackText">
                              Applied Filters
                            </span>
                            <a
                              className="latoBold font12 capText"
                              href="javascript:;"
                              onClick={() =>
                                this.RemoveMultipleFilter(
                                  this.state.FiltersData.max_price
                                )
                              }
                            >
                              Clear
                            </a>
                          </div>
                          <ul className="appliedFilters">
                            {this.state.appliedFilterVal.map((i, j) => (
                              <li>
                                <span className="latoBold">{i.label}</span>
                                <a
                                  href="javascript:;"
                                  onClick={() =>
                                    this.RemoveSingleFilter(
                                      i,
                                      j,
                                      this.state.FiltersData.max_price
                                    )
                                  }
                                ></a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <p
                          className="makeFlex spaceBetween end"
                          style={{ justifyContent: "flex-start" }}
                        >
                          <span className="font20 blackText">
                            Select Filters
                          </span>
                        </p>
                      )}
                        
                        <div
                        className="filterRow"
                        id="hlistpg_fr_star_category"
                        style={{ marginBottom: 30 }}
                      >
                        <div className="latoBold font16 blackText appendBottom15 makeFlexNew hrtlCenter">
                          {" "}
                          Price
                        </div>
                        <InputRange
                          maxValue={this.state.FiltersData.max_price}
                          minValue={0}
                          value={this.state.valuePrice}
                          onChange={(value) =>
                            this.setState({ valuePrice: value })
                          }
                          onChangeComplete={(value) => this.changePrice(value)}
                        />
                        <span className="minValue">
                          <FontAwesomeIcon
                            icon={faEuroSign}
                            style={{ fontSize: "13px", color: "#555" }}
                          ></FontAwesomeIcon>{" "}
                          {this.state.valuePrice.min}
                        </span>
                        <span className="maxValue">
                          <FontAwesomeIcon
                            icon={faEuroSign}
                            style={{ fontSize: "13px", color: "#555" }}
                          ></FontAwesomeIcon>{" "}
                          {this.state.valuePrice.max}
                        </span>
                      </div>
                        <div className="filterRow" id="hlistpg_fr_star_category">
                          <div className="latoBold font16 blackText appendBottom15 makeFlexNew hrtlCenter">
                            Location
                          </div>
                          <ul className="filterList">
                        {Object.values(this.state.FiltersData.location).sort((a, b) => parseFloat(b.count) - parseFloat(a.count)).map(
                          (i, j) => (
                            <li>
                              <label>
                                <input
                                  type="checkbox"
                                  className="icheck"
                                  onChange={this.CheckAppliedFilterLocation}
                                  name={i.filter_label}
                                  checked={
                                    !!this.state.checkedItems.get(
                                      i.filter_label
                                    )
                                  }
                                  disabled={
                                    this.state.packageData == null ? true : false
                                  }
                                />
                                <span className="cat_star" style={{textTransform:'capitalize'}}>
                                  {i.filter_label}
                                </span>{" "}
                                <small className="star_score">
                                  ({i.count})
                                </small>{" "}
                              </label>
                            </li>
                          )
                        )}
                      </ul>
                        </div>
                        {/* <div className="filterRow" id="hlistpg_fr_star_category">
                        <div className="latoBold font16 blackText appendBottom15 makeFlex hrtlCenter">
                          Category
                        </div>
                    
                    { this.state.CategotyThem &&(<CheckboxTree
                        nodes={this.state.CategotyThem &&(this.state.CategotyThem)}
                        checked={this.state.checked}
                        expanded={this.state.expanded}
                        onCheck={checked => this.CheckAppliedFilterCategory(checked)}
                        onExpand={expanded => this.setState({ expanded })}
                        // iconsClass="fa4"
                        icons={{
                          check: <span className="rct-icon rct-icon-check" />,
                          uncheck: <span className="rct-icon rct-icon-uncheck" />,
                          halfCheck: <span className="rct-icon rct-icon-half-check" />,
                          expandClose: <span className="rct-icon rct-icon-expand-close" />,
                          expandOpen: <span className="rct-icon rct-icon-expand-open" />,
                          expandAll: <span className="rct-icon rct-icon-expand-all" />,
                          collapseAll: <span className="rct-icon rct-icon-collapse-all" />,
                          parentClose: <span className="rct-icon rct-icon-parent-close" />,
                          parentOpen: <span className="rct-icon rct-icon-parent-open" />,
                          leaf: <span className="rct-icon rct-icon-leaf" />,
                      }}
                      disabled={this.state.packageData == null ? true : false}
                        />)}
                      </div> */}


                      <div className="appendBottom35">
                        <div
                          className="filterRow"
                          id="hlistpg_fr_star_category"
                        >
                          <div className="latoBold font16 blackText appendBottom15 makeFlexNew hrtlCenter">
                            Duration
                          </div>
                          <ul className="filterList">
                            {Duration.map((item, index) => (
                              <li>
                                <label>
                                  <input
                                    type="checkbox"
                                    className="icheck"
                                    onChange={this.CheckAppliedFilter}
                                    name={item.name}
                                    checked={
                                      !!this.state.checkedItems.get(item.name)
                                    }
                                    disabled={
                                      this.state.packageData == null
                                        ? true
                                        : false
                                    }
                                  />
                                  <span className="cat_star">{item.name}</span>
                                </label>
                              </li>
                            ))}
                          </ul>
                        </div>

                       
                      </div>

                      <div className="filterRow" id="hlistpg_fr_star_category">
                          <div className="latoBold font16 blackText appendBottom15 makeFlexNew hrtlCenter">Time of Day</div>
                          <ul className="filterList">

                              {TimeOfDays.map((item, index) => (
                                  <li>
                                      <label>
                                          <input type="checkbox" className="icheck" onChange={this.CheckTimeOfDaysFilter} name={item.name} checked={!!this.state.checkedItems.get(item.name)} disabled={this.state.packageData == null ? true : false} />
                                          <span className="cat_star">{item.name}</span></label>
                                  </li>
                              ))}

                          </ul>
                        </div>
                      
                     
                    </div>
                  )}
                </>
              )}

              <div className="listingWrap">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  {this.state.packageData === null ? (
                   <>
                   <span style={{ color: "#55575b", paddingTop: 0 }}>
                   
                   </span>
                 </>
                  ) : (
                    <>
                      {this.state.packageData == "no_package" ? (
                         <>
                         <span style={{ color: "#55575b", paddingTop: 0 }}>
                          {/* 0 result */}
                         </span>
                       </>
                      ) : (
                        <>
                          <span style={{ color: "#55575b", paddingTop: 0 }}>
                            {this.state.packageData.length == 1
                              ? "1 result"
                              : this.state.packageData.length + " results"}
                          </span>
                        </>
                      )}
                    </>
                  )}
                  {this.state.packageData !== null &&  this.state.packageData != "no_package" &&( 
                  <div
                    className="hsw_viewMap_content hsw_viewMap"
                    style={{ display: "flex", paddingTop: 0 }}
                  >
                    <span
                      class="latoBold"
                      style={{ color: "#55575b", fontWeight: "600 !important" }}
                    >
                      {" "}
                      Sort By:&nbsp;
                    </span>
                    <div class="customSelect">
                      <span
                        class="customSelectTitle  latoBold"
                        style={{ color: "#008cff" }}
                        onClick={this.showSorting}
                      >
                        {this.state.sortingSelect}
                      </span>
                      {this.state.sorting && (
                        <ul class="customSelectOptions latoBold">
                          {SortArr.map((item, index) => (
                            <li
                              className={
                                this.state.sortingSelect == item.name
                                  ? "selectedActiveSort"
                                  : ""
                              }
                              key={index}
                              onClick={() => this.handleSortingChange(item)}
                            >
                              {item.name}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>)}

                </div>
                <div className="container container-custom margin_30_95">
                  {this.state.packageData === null ? (
                    <>
                      <HotelListSkeleton />
                      <HotelListSkeleton />
                      <HotelListSkeleton />
                    </>
                  ) : this.state.packageData == "no_package" ? (
                    <ExperiencesSoldout/>
                  ) : (
                    <>
                      <div className="appendBottom20">
                        <div
                          className="covidCard"
                          style={{
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                          }}
                        >
                          <div className="covidCard__header">
                            <p className="latoBlack font22 blackText appendBottom3">
                              <font color="#000000">Important Information</font>
                            </p>
                            <p className="font16 lineHight20 appendBottom15">
                              <font color="#000000">
                                <br />
                                We request you to keep track of latest guideline
                                and restrictions.
                              </font>
                            </p>
                          </div>
                          <div className="covidCard__desc">
                            <div className="covidCard__descLeft">
                              <p
                                className="makeFlex hrtlCenter appendBottom8"
                                style={{ marginTop: 0 }}
                              >
                                <span className="appendRight10">
                                  <img
                                    width="20"
                                    src="images/shield.png"
                                    alt=""
                                  />
                                </span>{" "}
                                <span className="latoBlack font16 blackText 111">
                                  <font color="#00dc7f">
                                    <b>My</b>
                                  </font>
                                  <font color="#000000">
                                    <b>Safety</b>
                                  </font>
                                  <font color="#000000">
                                    {" "}
                                    - Safe and Hygienic Stays
                                  </font>
                                </span>
                              </p>
                              <ul
                                className="covidCard__list2"
                                style={{ marginTop: 10 }}
                              >
                                <li>
                                  <span className="appendRight5">
                                    {" "}
                                    <img
                                      width="14"
                                      src="images/Green.png"
                                      alt=""
                                    />
                                  </span>
                                  <span className="">
                                    <font color="#000000">
                                      Sanitized Environment
                                    </font>
                                  </span>
                                </li>
                                <li>
                                  <span className="appendRight5">
                                    {" "}
                                    <img
                                      width="14"
                                      src="images/Green.png"
                                      alt=""
                                    />
                                  </span>
                                  <span className="">
                                    <font color="#000000">Trained Staff</font>
                                  </span>
                                </li>
                                <li>
                                  <span className="appendRight5">
                                    {" "}
                                    <img
                                      width="14"
                                      src="images/Green.png"
                                      alt=""
                                    />
                                  </span>
                                  <span className="">
                                    <font color="#000000">Safe Practices</font>
                                  </span>
                                </li>
                                <li>
                                  <span className="appendRight5">
                                    {" "}
                                    <img
                                      width="14"
                                      src="images/Green.png"
                                      alt=""
                                    />
                                  </span>
                                  <span className="">
                                    <font color="#000000">Safe Dining</font>
                                  </span>
                                </li>
                              </ul>
                            </div>
                            {/* <a className="covidCard__learnMore latoBlack font14"><font color="#008CFF">DETAILED COVID-19 GUIDELINES</font></a> */}
                          </div>
                        </div>
                      </div>
                      {this.state.packageData.map((i, j) => {
                        if (i != "no_package") {
                          return (
                            <>
                              {Object.values(i).map((key1, index) => (
                                <TourPackageList
                                  tour_gallery={key1.tour_gallery}
                                  tour_description={key1.tour_description}
                                  tour_price={key1.tour_price}
                                  tour_data={key1.tour_data}
                                  dateSelected={this.state.selectPackageDayNew}
                                  tour_day={key1.tour_day}
                                  tour_time={key1.tour_timing}
                                  tour_exclusion={key1.tour_exclusion}
                                  tour_inclusion={key1.tour_inclusion}
                                  specialOffer={key1.specialOffer}
                                  forMeal={key1.forMeal}
                                  tour_price_details={key1.tour_price_details}
                                  tour_price_schedule={key1.tour_price_schedule}
                                  tour_price_schedule_new={key1.tour_price_schedule_new}
                                />
                              ))}
                            </>
                          );
                        }
                      })}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
